export const PERSISTED_AT_SET_VALUE = 'raOptimal/setValue/persistedAt';

export const setPersistedAtValue = () => ({ type: PERSISTED_AT_SET_VALUE });
